import { create } from 'zustand';
import { Item } from 'src/types/api/ListFolderFiles';

interface FavoriteTableState {
  searchTerm: string;
  selectedFolder: Item | null;
  selectedFile: Item | null;
  
  // Actions
  setSearchTerm: (term: string) => void;
  setSelectedFolder: (folder: Item | null) => void;
  setSelectedFile: (file: Item | null) => void;
  
  // Reset all selections
  resetSelections: () => void;
}

export const useFavoriteTableStore = create<FavoriteTableState>((set) => ({
  searchTerm: '',
  selectedFolder: null,
  selectedFile: null,
  
  setSearchTerm: (term) => set({ searchTerm: term }),
  setSelectedFolder: (folder) => set({ selectedFolder: folder }),
  setSelectedFile: (file) => set({ selectedFile: file }),
  
  resetSelections: () => set({
    selectedFolder: null,
    selectedFile: null,
  }),
}));
